export const TOOLTIP_ICON_COLOR = '#989CAF'
